// extracted by mini-css-extract-plugin
export default {"warningText":"Modal_warningText__2zj1p","footerContainer":"Modal_footerContainer__9+JHO"};